import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '',
  timeout: 10000,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})

// 不需要token验证的白名单
const whiteList = [
  '/api/auth/login',
  '/api/auth/register',
  '/api/auth/captcha',
  '/api/auth/resetPassword',
  '/api/email/send'
];

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 如果是白名单中的接口，不需要token
    if (whiteList.some(path => config.url.includes(path))) {
      return config;
    }
    
    // 从localStorage获取token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    } else {
      // 如果不是白名单接口且没有token，拒绝请求
      return Promise.reject(new Error('No token provided'));
    }
    return config;
  },
  error => {
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    if (response.status === 200) {
      // 判断业务状态码
      if (response.data.code === 0 || response.data.success) {
        // 直接返回response.data，让具体的组件处理数据结构
        return response.data;
      } else {
        // 处理业务错误
        const error = new Error(response.data.msg || '业务处理失败');
        error.code = response.data.code;
        return Promise.reject(error);
      }
    }
    return Promise.reject(new Error('请求失败'));
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // token过期或未登录
          localStorage.clear(); // 清除所有本地存储
          router.push('/login'); // 跳转到登录页
          break;
        case 403:
          Message.error('权限不足');
          break;
        case 404:
          Message.error('请求的资源不存在');
          break;
        case 500:
          Message.error('服务器错误');
          break;
        default:
          Message.error('网络错误');
      }
    }
    return Promise.reject(error);
  }
);

// token验证方法
export const validateToken = () => {
  return new Promise((resolve, reject) => {
    service.post('/api/auth/validate')
      .then(response => {
        if (response.code === 0) {
          resolve(true);
        } else {
          reject(new Error(response.msg || 'Token验证失败'));
        }
      })
      .catch(error => {
        reject(error);
      });
  });
};

export default service
